<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-dialog" role="document">
      <div class="modal-content radius-8 px-4">
        <div class="text-center">
          <h3 class="modal-title mb-8">
            {{ customer.translations.place_order }}
          </h3>

          <p class="modal-text mt-1">
            {{ customer.translations.team_size_breakdown_text }}
          </p>

          <div class="d-flex flex-column justify-content-center max-280 mt-3">
            <button
              class="btn primary-btn px-1 d-flex align-items-center justify-content-center"
              @click="handleContinue"
            >
              {{ customer.translations.continue_order }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    order: {
      type: Object,
      required: false
    },
    customer: {
      type: Object,
      required: true
    }
  },

  emits: ['close'],

  methods: {
    handleContinue() {
      this.$emit('close')
    }
  }
};
</script>
